import { render } from "./FirSectionList.vue?vue&type=template&id=38db5aad&scoped=true"
import script from "./FirSectionList.vue?vue&type=script&lang=js"
export * from "./FirSectionList.vue?vue&type=script&lang=js"

import "./FirSectionList.vue?vue&type=style&index=0&id=38db5aad&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38db5aad"]])

export default __exports__